import React, { FC, useEffect, useState } from 'react';
import { colorConstants } from 'config/colorConstants';
import { Radio } from 'antd';
import { CustomModal } from 'components/molecules/PricingSimulator/Modals/CreateEditProjectContainer';
import Item from 'antd/lib/list/Item';

type Item = {
    key: string | number;
    label: string;
};
type Props = {
    open: boolean;
    value: Item;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmit: (selected: Item) => void;
    items: Item[];
    title: string;
    menuTitle: string;
};

const RadioMenuPopup: FC<Props> = ({ open, onCancel, onSubmit, value, items, title, menuTitle }) => {
    const [selected, setSelected] = useState<Item>(value);

    //reset on popup close
    useEffect(() => {
        if (!open) {
            setSelected(value);
        }
    }, [open]);

    return (
        <div>
            <CustomModal
                bodyStyle={{ paddingTop: 0 }}
                style={{ borderRadius: 8 }}
                cancelButtonProps={{ style: { borderRadius: 6 } }}
                okButtonProps={{ style: { borderRadius: 6 } }}
                okText={'Apply'}
                maskClosable={false}
                destroyOnClose
                centered
                onOk={() => {
                    onSubmit(selected);
                }}
                open={open}
                width={420}
                onCancel={(e) => {
                    onCancel(e);
                }}
                title={title}
            >
                <div className="rounded px-6 py-4 border border-backgroundGreyAlt6">
                    <div className="font-xs mb-3  text-fontGreyAlt">Choose view option</div>
                    <Radio.Group
                        onChange={(e) => {
                            setSelected(e.target.value);
                        }}
                        value={selected}
                    >
                        {menuTitle}
                        {items.map((item) => (
                            <div>
                                <Radio
                                    style={{ color: colorConstants.blackAlt1, width: 200, marginBottom: 4 }}
                                    value={item}
                                >
                                    <span className="font-xs">{item.label}</span>
                                </Radio>
                            </div>
                        ))}
                    </Radio.Group>
                </div>
            </CustomModal>
        </div>
    );
};

export default RadioMenuPopup;
